module.exports = __webpack_public_path__ + "ab2468b27397cb554d476893e5551610.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-19.png
// module id = 1754
// module chunks = 0